<template>
	<v-dialog v-model="dialog" max-width="800px">
		<template v-slot:activator="{ on, attrs }">
			<v-btn class="ml-2 app-bar-btn" :color="btn ? 'secondary' : 'primary'" dark @click.stop="dialog = true" v-bind="attrs" v-on="on">
				<v-icon class="mr-1">mdi-clipboard-text-clock-outline</v-icon>
				削除履歴
			</v-btn>
		</template>
		<v-card :tile="$vuetify.breakpoint.xs">
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">ファイルの削除履歴</v-app-bar-title>
				<v-spacer />
				<v-btn icon color="white" dark @click="close()" large><v-icon>mdi-close</v-icon></v-btn>
			</v-app-bar>
			<div class="table-container">
				<v-data-table
					locale="ja-JP"
					:headers="headers"
					:items="deleted_files"
					:mobile-breakpoint="240"
					hide-default-footer
					disable-filtering
					disable-sort
					:items-per-page="20"
					disable-pagination
					no-data-text="データがありません。"
				>
					<template v-slot:item="{ item }">
						<tr class="no-click">
							<td>{{ item.destroy_date | dateFormatter }}</td>
							<td>{{ item.destroy_file_name }}</td>
							<td>{{ item.destroy_user.full_name }}</td>
						</tr>
					</template>
				</v-data-table>
			</div>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from "moment/min/moment.min.js"

export default {
	props: {
		btn: Boolean,
		deleted_files: {
			type: Array,
			default: [],
		},
	},
	filters: {
		dateFormatter: function (date) {
			if (!date) return ""
			return moment(date).format("YYYY/MM/DD")
		},
	},
	data() {
		return {
			id: this.$route.params["id"],
			headers: [
				{ text: "削除日", value: "", width: "100px" },
				{ text: "ファイル名", value: "", width: "300px" },
				{ text: "削除者名", value: "", width: "100px" },
			],
			dialog: false,
		}
	},

	methods: {
		close() {
			this.dialog = false
		},
	},
}
</script>
<style lang="scss" scoped>
@import "../../../stylesheet/variable.scss";
.deleted_files {
	border: $main-color solid 2px;
	border-radius: 5px;
	&__box {
		max-width: 800px;
	}
	&__title {
		margin: 0 auto;
		background: $main-color;
		max-width: 800px;
		display: flex;
		justify-content: space-between;
		h2 {
			padding: 5px;
			color: #fefefe;
			margin-left: 10px;
		}
	}
}
</style>
